import { render, staticRenderFns } from "./FaultGroupEdit.vue?vue&type=template&id=63eb55c4&scoped=true"
import script from "./FaultGroupEdit.vue?vue&type=script&lang=js"
export * from "./FaultGroupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63eb55c4",
  null
  
)

export default component.exports